import InternalRedirect, { InternalRedirectWithHistory } from "./InternalRedirect";

export default InternalRedirect;
export { InternalRedirect, InternalRedirectWithHistory };
